

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Badge, Table, Spinner, Container, Button, Alert, Modal } from 'react-bootstrap';
// import config from '../../Common/Configurations/APIConfig';
// import { useNavigate } from 'react-router-dom';
// import DefaultData from '../../Common/CompanyData/DefaultData';

// function CustomerOrders() {
//     const [orders, setOrders] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState('');
    
//     // ================= MODAL STATES =================
//     const [showItemsModal, setShowItemsModal] = useState(false);
//     const [selectedOrder, setSelectedOrder] = useState(null);

//     const navigate = useNavigate();

//     const userId = localStorage.getItem('userId');
//     const userName = localStorage.getItem('userName') || 'Customer';
//     const currency = DefaultData.DEFAULTCURRENCY || 'NGN';
//     const THEME_COLOR = '#065f46';

//     useEffect(() => {
//         if (!userId) { setError('Please login'); setLoading(false); return; }
//         fetchCustomerOrders();
//     }, [userId]);

//     const fetchCustomerOrders = async () => {
//         try {
//             setLoading(true);
//             const res = await axios.get(`${config.APIACTIVEURL}${config.GETOERDERSBYUSERID}/${userId}`);
            
//             let data = res.data?.data || res.data || [];
//             // Sort by most recent
//             data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            
//             setOrders(data);
//         } catch (err) { 
//             console.error("Fetch Error", err);
//             setError('Failed to load orders.'); 
//         } finally { setLoading(false); }
//     };

//     // --- INPUT = OUTPUT TIMING FIX ---
//     const formatDate = (dateString) => {
//         if (!dateString) return '-';
//         const cleanDate = dateString.replace('Z', '').split('.')[0];
//         const date = new Date(cleanDate);
        
//         const dStr = date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
//         const tStr = date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });

//         return `${dStr} at ${tStr}`;
//     };

//     const getStatusColor = (status) => {
//         const s = status?.toLowerCase();
//         if (['pending', 'processing', 'order placed'].includes(s)) return 'warning';
//         if (['shipped', 'dispatched', 'confirmed'].includes(s)) return 'info';
//         if (['delivered', 'completed'].includes(s)) return 'success';
//         if (s === 'cancelled') return 'danger';
//         return 'secondary';
//     };

//     const formatCurrency = (amount) => `${currency} ${parseFloat(amount || 0).toFixed(2)}`;

//     if (loading) return <div className="text-center" style={{ marginTop: '200px' }}><Spinner animation="border" style={{color: THEME_COLOR}} /></div>;

//     return (
//         <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh', width: '100%' }}>
//             <Container fluid className="px-4" style={{ marginTop: '120px', paddingBottom: '50px' }}>
//                 <div className="bg-white shadow-sm rounded-4 p-4 border-0">
//                     {/* --- HEADER --- */}
//                     <div className="d-flex justify-content-between align-items-center mb-4">
//                         <div>
//                             <h2 className="fw-bold mb-1">My Orders</h2>
//                             <p className="text-muted mb-0">Welcome back, <span className="fw-bold text-primary">{userName}</span></p>
//                         </div>
//                         <Badge bg="primary" className="rounded-pill px-3 py-2 fs-6">{orders.length} Order(s)</Badge>
//                     </div>

//                     {/* --- TABLE --- */}
//                     <div className="table-responsive">
//                         <table className="table table-hover align-middle mb-0">
//                             <thead className="table-light">
//                                 <tr className="small text-uppercase text-muted">
//                                     <th className="ps-3 py-3">Order No</th>
//                                     <th>Status</th>
//                                     <th>Total Amount</th>
//                                     <th>Order Date</th>
//                                     <th>Shipping Address</th>
//                                     <th className="text-center">Actions</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {orders.length === 0 ? (
//                                     <tr><td colSpan="6" className="text-center py-4 text-muted">You haven't placed any orders yet.</td></tr>
//                                 ) : (
//                                     orders.map((order) => (
//                                         <tr key={order.orderId}>
//                                             <td className="ps-3 py-3 fw-bold text-primary">{order.orderNo}</td>
//                                             <td><Badge bg={getStatusColor(order.status)} className="rounded-pill px-3 py-2">{order.status}</Badge></td>
//                                             <td><span className="fw-bold text-success" style={{ fontSize: '1.1rem' }}>{formatCurrency(order.totalAmount)}</span></td>
//                                             <td className="text-muted">{formatDate(order.createdAt)}</td>
//                                             <td className="small text-muted">{order.shippingAddress || 'N/A'}</td>
//                                             <td className="text-center">
//                                                 <Button 
//                                                     variant="link" 
//                                                     className="p-0 text-success" 
//                                                     title="View Items"
//                                                     onClick={() => { setSelectedOrder(order); setShowItemsModal(true); }}
//                                                 >
//                                                     <i className="ri-list-check-2 fs-4"></i>
//                                                 </Button>
//                                             </td>
//                                         </tr>
//                                     ))
//                                 )}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>
//             </Container>

//             {/* --- MODAL: ORDER ITEMS BREAKDOWN --- */}
//             <Modal show={showItemsModal} onHide={() => setShowItemsModal(false)} size="lg" centered>
//                 <Modal.Header closeButton className="border-0">
//                     <Modal.Title className="fw-bold" style={{ color: THEME_COLOR }}>
//                         <i className="ri-shopping-bag-line me-2"></i>
//                         Order Items: {selectedOrder?.orderNo}
//                     </Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body className="p-0">
//                     <Table responsive hover className="mb-0">
//                         <thead className="bg-light small text-uppercase">
//                             <tr>
//                                 <th className="ps-4">Product Name</th>
//                                 <th className="text-center">Unit Price</th>
//                                 <th className="text-center">Qty</th>
//                                 <th className="text-end pe-4">Subtotal</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {selectedOrder?.orderItems?.map((item, idx) => (
//                                 <tr key={idx}>
//                                     <td className="ps-4">
//                                         <div className="fw-bold text-dark">{item.product?.productName || 'Product'}</div>
//                                         <div className="small text-muted">{item.product?.category}</div>
//                                     </td>
//                                     <td className="text-center">{formatCurrency(item.unitPrice)}</td>
//                                     <td className="text-center">x {item.quantity}</td>
//                                     <td className="text-end pe-4 fw-bold text-success">
//                                         {formatCurrency(item.unitPrice * item.quantity)}
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                         <tfoot className="table-light fw-bold">
//                             <tr>
//                                 <td colSpan="3" className="text-end ps-4">Total Amount Paid:</td>
//                                 <td className="text-end pe-4 text-success" style={{ fontSize: '1.2rem' }}>
//                                     {formatCurrency(selectedOrder?.totalAmount)}
//                                 </td>
//                             </tr>
//                         </tfoot>
//                     </Table>
//                 </Modal.Body>
//                 <Modal.Footer className="border-0">
//                     <div className="w-100 d-flex justify-content-between align-items-center px-2">
//                         <small className="text-muted italic">Ordered on: {formatDate(selectedOrder?.createdAt)}</small>
//                         <Button variant="secondary" onClick={() => setShowItemsModal(false)}>Close</Button>
//                     </div>
//                 </Modal.Footer>
//             </Modal>
//         </div>
//     );
// }

// export default CustomerOrders;
//web view 


import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Badge, Table, Spinner, Container, Button, Alert, Modal } from 'react-bootstrap';
import config from '../../Common/Configurations/APIConfig';
import { useNavigate } from 'react-router-dom';
import DefaultData from '../../Common/CompanyData/DefaultData';

function CustomerOrders() {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    
    // ================= MODAL STATES =================
    const [showItemsModal, setShowItemsModal] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);

    const navigate = useNavigate();

    const userId = localStorage.getItem('userId');
    const userName = localStorage.getItem('userName') || 'Customer';
    const currency = DefaultData.DEFAULTCURRENCY || 'NGN';
    const THEME_COLOR = '#065f46';

    useEffect(() => {
        if (!userId) { setError('Please login'); setLoading(false); return; }
        fetchCustomerOrders();
    }, [userId]);

    const fetchCustomerOrders = async () => {
        try {
            setLoading(true);
            const res = await axios.get(`${config.APIACTIVEURL}${config.GETOERDERSBYUSERID}/${userId}`);
            
            let data = res.data?.data || res.data || [];
            // Sort by most recent
            data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            
            setOrders(data);
        } catch (err) { 
            console.error("Fetch Error", err);
            setError('Failed to load orders.'); 
        } finally { setLoading(false); }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const cleanDate = dateString.replace('Z', '').split('.')[0];
        const date = new Date(cleanDate);
        
        const dStr = date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
        const tStr = date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });

        return `${dStr} at ${tStr}`;
    };

    const getStatusColor = (status) => {
        const s = status?.toLowerCase();
        if (['pending', 'processing', 'order placed'].includes(s)) return 'warning';
        if (['shipped', 'dispatched', 'confirmed'].includes(s)) return 'info';
        if (['delivered', 'completed'].includes(s)) return 'success';
        if (s === 'cancelled') return 'danger';
        return 'secondary';
    };

    const formatCurrency = (amount) => `${currency} ${parseFloat(amount || 0).toFixed(2)}`;

    if (loading) return <div className="text-center" style={{ marginTop: '200px' }}><Spinner animation="border" style={{color: THEME_COLOR}} /></div>;

    return (
        <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh', width: '100%' }}>
            <Container fluid className="px-2 px-md-4" style={{ marginTop: '100px', paddingBottom: '50px' }}>
                <div className="bg-white shadow-sm rounded-4 p-3 p-md-4 border-0">
                    {/* --- HEADER --- */}
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3">
                        <div>
                            <h2 className="fw-bold mb-1">My Orders</h2>
                            <p className="text-muted mb-0">Welcome back, <span className="fw-bold text-primary">{userName}</span></p>
                        </div>
                        <Badge bg="primary" className="rounded-pill px-3 py-2 fs-6 align-self-start">{orders.length} Order(s)</Badge>
                    </div>

                    {/* --- TABLE (Desktop View) --- */}
                    <div className="table-responsive d-none d-md-block">
                        <table className="table table-hover align-middle mb-0">
                            <thead className="table-light">
                                <tr className="small text-uppercase text-muted">
                                    <th className="ps-3 py-3">Order No</th>
                                    <th>Status</th>
                                    <th>Total Amount</th>
                                    <th>Order Date</th>
                                    <th>Shipping Address</th>
                                    <th className="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orders.length === 0 ? (
                                    <tr><td colSpan="6" className="text-center py-4 text-muted">You haven't placed any orders yet.</td></tr>
                                ) : (
                                    orders.map((order) => (
                                        <tr key={order.orderId}>
                                            <td className="ps-3 py-3 fw-bold text-primary">{order.orderNo}</td>
                                            <td><Badge bg={getStatusColor(order.status)} className="rounded-pill px-3 py-2">{order.status}</Badge></td>
                                            <td><span className="fw-bold text-success" style={{ fontSize: '1.1rem' }}>{formatCurrency(order.totalAmount)}</span></td>
                                            <td className="text-muted">{formatDate(order.createdAt)}</td>
                                            <td className="small text-muted">{order.shippingAddress || 'N/A'}</td>
                                            <td className="text-center">
                                                <Button 
                                                    variant="link" 
                                                    className="p-0 text-success" 
                                                    onClick={() => { setSelectedOrder(order); setShowItemsModal(true); }}
                                                >
                                                    <i className="ri-list-check-2 fs-4"></i>
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* --- CARD VIEW (Mobile View) --- */}
                    <div className="d-md-none">
                        {orders.length === 0 ? (
                            <div className="text-center py-4 text-muted">No orders found.</div>
                        ) : (
                            orders.map((order) => (
                                <div key={order.orderId} className="border rounded-3 p-3 mb-3 shadow-sm">
                                    <div className="d-flex justify-content-between align-items-start mb-2">
                                        <span className="fw-bold text-primary">{order.orderNo}</span>
                                        <Badge bg={getStatusColor(order.status)} className="rounded-pill">{order.status}</Badge>
                                    </div>
                                    <div className="mb-2">
                                        <small className="text-muted d-block">Order Date:</small>
                                        <span className="small">{formatDate(order.createdAt)}</span>
                                    </div>
                                    <div className="mb-3">
                                        <small className="text-muted d-block">Total Amount:</small>
                                        <span className="fw-bold text-success fs-5">{formatCurrency(order.totalAmount)}</span>
                                    </div>
                                    <div className="d-grid">
                                        <Button 
                                            variant="outline-success" 
                                            size="sm"
                                            onClick={() => { setSelectedOrder(order); setShowItemsModal(true); }}
                                        >
                                            <i className="ri-list-check-2 me-1"></i> View Order Items
                                        </Button>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </Container>

            {/* --- MODAL: ORDER ITEMS BREAKDOWN --- */}
            <Modal show={showItemsModal} onHide={() => setShowItemsModal(false)} size="lg" centered>
                <Modal.Header closeButton className="border-0">
                    <Modal.Title className="fw-bold" style={{ color: THEME_COLOR }}>
                        <i className="ri-shopping-bag-line me-2"></i>
                        Items: {selectedOrder?.orderNo}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0">
                    <Table responsive hover className="mb-0">
                        <thead className="bg-light small text-uppercase">
                            <tr>
                                <th className="ps-3 ps-md-4">Product</th>
                                <th className="text-center">Price</th>
                                <th className="text-center">Qty</th>
                                <th className="text-end pe-3 pe-md-4">Subtotal</th>
                            </tr>
                        </thead>
                        <tbody>
                            {selectedOrder?.orderItems?.map((item, idx) => (
                                <tr key={idx}>
                                    <td className="ps-3 ps-md-4">
                                        <div className="fw-bold text-dark small">{item.product?.productName || 'Product'}</div>
                                    </td>
                                    <td className="text-center small">{formatCurrency(item.unitPrice)}</td>
                                    <td className="text-center small">x{item.quantity}</td>
                                    <td className="text-end pe-3 pe-md-4 fw-bold text-success small">
                                        {formatCurrency(item.unitPrice * item.quantity)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot className="table-light fw-bold">
                            <tr>
                                <td colSpan="3" className="text-end ps-4">Total Paid:</td>
                                <td className="text-end pe-3 pe-md-4 text-success">
                                    {formatCurrency(selectedOrder?.totalAmount)}
                                </td>
                            </tr>
                        </tfoot>
                    </Table>
                </Modal.Body>
                <Modal.Footer className="border-0">
                    <Button variant="secondary" onClick={() => setShowItemsModal(false)}>Close</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default CustomerOrders;